/* eslint-disable react/display-name */
import React from 'react';
import {
  string,
  arrayOf,
  shape,
  func,
  bool,
} from 'prop-types';
import classNames from 'classnames';

import './Select.scss';

const Select = React.forwardRef(({
  className,
  value,
  placeholder,
  options,
  onChange,
  disabled,
  dataSelectorId,
  autoComplete,
}, ref) => (
  <select
      ref={ref}
      className={classNames(className, ['select', { placeholder: !value && placeholder }])}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      data-selector={dataSelectorId}
      data-selector-type="select"
      data-selector-disabled={disabled}
      data-selector-value={value}
      autoComplete={autoComplete}
    >
      {placeholder && !value && (
      <option key={placeholder} value="" disabled>
        {placeholder}
      </option>
      )}
      {options.map(({ label, value: optionValue }) => (
        <option key={`${optionValue}-${label}`} className="no-placeholder" value={optionValue} data-selector={dataSelectorId} data-selector-type="select-option" data-selector-value={optionValue}>
          {label || optionValue}
        </option>
      ))}
    </select>
));

Select.propTypes = {
  className: string,
  value: string,
  placeholder: string,
  options: arrayOf(shape({
    label: string,
    value: string.isRequired,
  })),
  onChange: func,
  disabled: bool,
  dataSelectorId: string,
  autoComplete: string,
};

Select.defaultProps = {
  className: null,
  value: null,
  placeholder: null,
  options: [],
  onChange: undefined,
  disabled: false,
  dataSelectorId: '',
  autoComplete: 'on',
};

export default Select;
